// @ts-nocheck
import Vue from 'vue';
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  localize,
} from 'vee-validate';
import id, {messages} from 'vee-validate/dist/locale/id.json';
import PhoneNumber from 'awesome-phonenumber';
import {ValidationRule} from 'vee-validate/dist/types/types';
import * as rules from 'vee-validate/dist/rules';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);

for (const [rule, validation] of Object.entries(rules)) {
  extend(rule, <ValidationRule>{
    ...validation,
    message: messages[rule],
  });
}

localize({
  id,
});

extend('phone', {
  message(fieldName) {
    return `${fieldName} yang aktif`;
  },
  validate(value) {
    return new Promise(resolve => {
      const phone = new PhoneNumber(value, 'id');
      resolve({valid: phone.isValid()});
    });
  },
});
extend('date', {
  message(fieldName) {
    return `${fieldName} is required`;
  },
  validate(value) {
    return new Promise(resolve => {
      resolve({
        valid: value === null ? true : false,
      });
    });
  },
});

extend('format_password', {
  message() {
    return 'Kata sandi harus memiliki minimal 1 angka, 1 huruf besar, 1 huruf kecil dan 1 karakter non-alfanumerik.';
  },
  validate(value) {
    return new Promise(resolve => {
      const passwordRegex = new RegExp(
        '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ !"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~])(?=.{8,})',
      );
      const matched = passwordRegex.test(value);
      resolve({valid: matched});
    });
  },
});
